<template>
  <div>
    <div class="nc_have_your_way" v-show='showCollege == true'>
      <div class="w">
        <div class="triangle"></div>
        <div class="diy">
          <p>量 身 订 制 你 的 专 属 数 据 解 决 方 案</p>
          <p @click='toggle'>立 即 试 用</p>
          <p>或致电: 400-666-8216</p>
        </div>
      </div>
    </div>

    <div class="apply_message" v-show="showApply">
      <div class="w">
          <h3>申请试用</h3>
          <p class="apply_desc">欢迎关注智维数据,请填写信息以便我们与您联系</p>
        <form>
          <div class="compony box">
            <label class="rule" for="compony"><span class="fontRed">*</span>企业名称</label>
            <input type="text" v-model="getInfo.company" id="compony">
            <p class="warnning" v-show='ifEmpty.company'>企业名称必须填写</p>
          </div>
          <div class="name box">
            <label class="rule" for="name"><span class="fontRed" >*</span>姓名</label>
            <input type="text" @change="checkInput($event).check('name')" v-model="getInfo.name" id="name">
            <p class="warnning" v-show='ifEmpty.name'>姓名不能为空</p>
          </div>

          <div class="phone box">
            <label class="rule" for="mobile"><span class="fontRed">*</span>电话</label>
            <input type="text" @change="checkInput($event).check('phone')" v-model="getInfo.phone" id="mobile">
            <p class="warnning" v-show='checkList.phone'>请输入正确的手机号码</p>
            <p class="warnning" v-show='ifEmpty.phone'>手机号码不能为空</p>
          </div>

          <div class="email box">
            <label class="rule" for="email"><span class="fontRed">*</span>邮箱</label>
            <input type="email" @change="checkInput($event).check('email')" v-model="getInfo.email" id="email">
            <p class="warnning" v-show='checkList.email'>请输入正确的邮箱地址</p>
            <p class="warnning" v-show='ifEmpty.email'>邮箱地址不能为空</p>
          </div>
          <div class="button" @click="getApply">提 交 申 请</div>
        </form>
      </div>

    </div>

    <div class="success" v-show="showSuccess">
      <div class="w">
        <div class="success_inner">
          <img src="../assets/img/school/success.svg" alt="">
          <p>信息提交成功</p>
          <span>您的信息已经提交，我们会尽快与您联系，谢谢！</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import md5 from 'js-md5';
export default {
  components: {

  },
  data(){
    return {
      showCollege:true,
      showApply:false,
      showSuccess:false,
      checkList:{
        name:'',
        email:'',
        phone:'',
        company:''
      },
      getInfo:{
        name:'',
        email:'',
        phone:'',
        company:''
      },
      ifEmpty:{
        name:'',
        email:'',
        phone:'',
        company:'',
      },
      flag:"NcompassNetwork",
      timestamp:Date.now()
    }

  },
  methods:{
    toggle(){
      this.showCollege = false;
      this.showApply = true;
    },
    isOk(){
      var ok = true;
      var {name, email, phone,company} = this.checkList;
      for(var i in this.getInfo){
        if(this.getInfo[i] == ''){
          ok = false;
          this.ifEmpty[i] =  true;
        }else{
          this.ifEmpty[i] =  false;
        }
      }
      if(name||email||phone||company){
        ok = false;
      }
      return ok;
    },
    getApply(){
      if(this.isOk()){
          var fd = new FormData();
          fd.append('phone',this.getInfo.phone);
          fd.append('name',this.getInfo.name);
          fd.append('email',this.getInfo.email);
          fd.append('company',this.getInfo.company);
          fetch("https://www.ncmps.com/api/applyMes",{
              method:"POST",
              body:fd,
              headers:{
                'timestamp':this.timestamp,
                'sign':md5(md5(`${this.timestamp}`)+`${this.flag}`)
              }
          }).then(res=>{
              res.json().then(json=>{
                if(json.code == 1){
                  this.showSuccess = true;
                  this.showApply = false;
                }else{
                  alert('申请失败,请重试');
                  return;
                }
              })
          })
      }else{
        return;
      }
    },
    checkInput(e){
      var val = e.currentTarget.value;
      var _this = this;
      var rules = {
        email(val){
          return  !/^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(val);
        },
        phone(val){
          return  !/^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/.test(val);
        },
        name(val){
          return !/^(?:[\u4e00-\u9fa5·]{2,16})$/.test(val);
        },
        isEmpty(val){
          return val == "";
        }
      };
      return {
        check(type){
          return rules[type] ? _this.checkList[type] = rules[type](val):  false;
        }
      }
    }
  }
};
</script>

<style lang='less' scoped>
.nc_have_your_way {
  width     : 100%;
  height    : 300px;
  background: linear-gradient(to right, #b830be, #4935f6);

  .triangle {
    width        : 0;
    height       : 0;
    margin       : 0 auto;
    border-top   : 30px solid white;
    border-bottom: 20px solid transparent;
    border-left  : 20px solid transparent;
    border-right : 20px solid transparent;
  }

  .diy {
    text-align: center;
    margin-top: 38px;

    p:nth-child(1) {
      font-size: 36px;
      color    : #eee;
    }

    p:nth-child(2) {
      display      : inline-block;
      margin       : 0 auto;
      background   : #07af85;
      color        : #eee;
      width        : 150px;
      height       : 42px;
      border-radius: 22px;
      line-height  : 42px;
      font-size    : 18px;
      margin-top   : 26px;
      cursor       : pointer;
    }

    p:nth-child(2):hover {
      background: #00cc99;
    }

    p:nth-child(3) {
      font-size : 14px;
      color     : rgba(238, 238, 238, 0.6);
      margin-top: 60px;
    }
  }
}
.apply_message{
  width     : 100%;
  height    : 600px;
  margin-bottom:40px;
  h3{
    font-size: 28px;
    color:#6924ff;
    text-align: center;
  }
  .apply_desc{
    font-size:26px;
    color: #6924ff;
    text-align: center;
    margin:30px auto;
    letter-spacing: 2px;
  }
   form {
      width:100%;
      text-align: center;
      padding-top:30px;

      .box {
            width        : 962px;
            margin       : 0 auto;
            margin-bottom: 40px;
            color        : #333;
      }
      .button {
        width        : 154px;
        height       : 40px;
        line-height  : 40px;
        background   : #6924ff;
        color        : white;
        border-radius: 20px;
        font-size    : 18px;
        margin       : 26px auto 20px auto;
        cursor       : pointer;
        text-align: center;
      }

      .button:hover {
        background: #6924ff;
      }

      input {
        height      : 44px;
        border      : 1px solid #afabab;
        width       : 400px;
        margin-right: 32px;
        font-size   : 16px;
        text-indent : 10px;
      }
      .rule {
          display     : inline-block;
          width       : 80px;
          text-align  : right;
          margin-right: 28px;
          cursor      : pointer;
      }
      .fontRed {
          color: #ea3e03;
      }

      .warnning {
          color: #ea3e03;
          text-indent: 108px;
          font-size  : 14px;
      }

   }


}
    .success {
     width: 100%;
    .success_inner {
        width          : 100%;
        justify-content: center;
        align-items    : center;
        display        : flex;
        flex-direction : column;
        padding-top    : 100px;

        img {
            width : 100px;
            height: 100px;
        }

        p {
            margin-top   : 64px;
            margin-bottom: 70px;
            font-size    : 24px;
            color        : #6924ff;
        }

        span {
            font-size    : 14px;
            margin-bottom: 150px;
        }
    }

}
</style>